module.exports = __webpack_public_path__ + "static/media/KM.41cb835a.svg";